const linkTextColor = "#0085ff";
const textEdgePattern = /[0-9A-Za-zÀ-ÖØ-öø-ÿ]$/;
const textStartPattern = /^[0-9A-Za-zÀ-ÖØ-öø-ÿ]/;
const linkInlineWrapperTags = ["SPAN", "STRONG", "EM", "B", "I", "U"];

const normalizeInlineLinkSpacing = (html = "") =>
  html
    .replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<a\b)/gi, "$1 $2")
    .replace(/(<\/a>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/gi, "$1 $2");

export const normalizeRecruitmentLinkHref = (href = "") => {
  const trimmedHref = href.trim();

  if (!trimmedHref || /^(javascript|data):/i.test(trimmedHref)) return "";
  if (/^(https?:|mailto:|tel:|\/|#)/i.test(trimmedHref)) return trimmedHref;

  return `https://${trimmedHref}`;
};

const setRecruitmentLinkAttributes = (link) => {
  const normalizedHref = normalizeRecruitmentLinkHref(
    link.getAttribute("href") || ""
  );

  if (normalizedHref) {
    link.setAttribute("href", normalizedHref);
  } else {
    link.removeAttribute("href");
  }

  link.setAttribute("target", "_blank");
  link.setAttribute("rel", "noopener noreferrer");
  link.style.color = linkTextColor;
  link.style.textDecoration = "underline";
  link.style.cursor = "pointer";
};

const getLinkSpacingNode = (link) => {
  let spacingNode = link;

  while (
    spacingNode.parentNode?.nodeType === 1 &&
    linkInlineWrapperTags.includes(spacingNode.parentNode.nodeName) &&
    spacingNode.parentNode.childNodes.length === 1
  ) {
    spacingNode = spacingNode.parentNode;
  }

  return spacingNode;
};

const addSpaceAroundLinkWhenNeeded = (link) => {
  const spacingNode = getLinkSpacingNode(link);
  const previousText = spacingNode.previousSibling?.textContent || "";
  const nextText = spacingNode.nextSibling?.textContent || "";
  const linkText = link.textContent || "";

  if (
    previousText &&
    linkText &&
    textEdgePattern.test(previousText) &&
    textStartPattern.test(linkText)
  ) {
    spacingNode.parentNode.insertBefore(
      document.createTextNode(" "),
      spacingNode
    );
  }

  if (
    nextText &&
    linkText &&
    textEdgePattern.test(linkText) &&
    textStartPattern.test(nextText)
  ) {
    spacingNode.parentNode.insertBefore(
      document.createTextNode(" "),
      spacingNode.nextSibling
    );
  }
};

const normalizeRecruitmentQuestionLinks = (html = "") => {
  if (typeof document === "undefined") {
    const linkStyle = `color: ${linkTextColor}; text-decoration: underline; cursor: pointer;`;

    return normalizeInlineLinkSpacing(
      html.replace(/<a\b([^>]*)>/gi, (match, attributes) => {
        if (!match) return match;

        let nextAttributes = attributes;

        nextAttributes = /target\s*=/i.test(nextAttributes)
          ? nextAttributes
          : `${nextAttributes} target="_blank"`;
        nextAttributes = /rel\s*=/i.test(nextAttributes)
          ? nextAttributes
          : `${nextAttributes} rel="noopener noreferrer"`;

        if (/style\s*=\s*"/i.test(nextAttributes)) {
          nextAttributes = nextAttributes.replace(
            /style\s*=\s*"([^"]*)"/i,
            `style="$1; ${linkStyle}"`
          );
        } else {
          nextAttributes = `${nextAttributes} style="${linkStyle}"`;
        }

        return `<a${nextAttributes}>`;
      })
    );
  }

  const template = document.createElement("template");
  template.innerHTML = html;

  template.content.querySelectorAll("a").forEach((link) => {
    setRecruitmentLinkAttributes(link);
    addSpaceAroundLinkWhenNeeded(link);
  });

  return normalizeInlineLinkSpacing(template.innerHTML);
};

export const normalizeRecruitmentQuestionHtml = (content = "") => {
  const normalizedContent = String(content || "").replace(
    /\bclassName\s*=/gi,
    "class="
  );

  return normalizeRecruitmentQuestionLinks(normalizedContent);
};
